import type { CSSProperties } from 'react';
import logoSky from '../assets/logo-crest-blue.png';
import logoOrange from '../assets/logo-crest-orange.png';

/**
 * CREST 标识：沿用原标识字形，只随主题换色。
 * 两张透明 PNG 同时输出，由 styles/theme-tokens.css 按 data-crest-theme 选择显示。
 */
export function CrestLogo({ height = 20, alt = 'CREST' }: { height?: number; alt?: string }) {
  return (
    <span className="crest-logo" style={{ display: 'inline-flex', height }}>
      <img className="crest-theme-img-sky" src={logoSky} alt={alt} style={{ height }} />
      <img className="crest-theme-img-orange" src={logoOrange} alt={alt} style={{ height }} />
    </span>
  );
}

/** 助手头像：标识首字母 C 放在白色圆角块里。 */
export function CrestMark({
  size = 30,
  markHeight = Math.round(size * 0.57),
  className,
}: {
  size?: number;
  markHeight?: number;
  className?: string;
}) {
  return (
    <span
      aria-hidden="true"
      className={['crest-mark', className].filter(Boolean).join(' ')}
      style={
        {
          width: size,
          height: size,
          '--crest-mark-h': `${markHeight}px`,
        } as CSSProperties
      }
    >
      <i>
        <img className="crest-theme-img-sky" src={logoSky} alt="" />
        <img className="crest-theme-img-orange" src={logoOrange} alt="" />
      </i>
    </span>
  );
}
